import React from "react";
import { Analytics } from "@vercel/analytics/react"
import * as Cochon from "./cochon.ts";

import img_yuflow from "./assets/wolf2.png"
import img_ilan from "./assets/ilan.png"
import img_wolf from "./assets/loup.png"
import img_pig from "./assets/cochon.png"

// Import houses
import house_star from "./assets/maison3.png"
import house_plus from "./assets/maison2.png"
import house_minus from "./assets/maison1.png"

import "./App.scss";


export default class App extends React.Component {

    constructor(props) {
        super(props);
        this.state= {
            stage: 0,
            wolf: [],
            pigs: [[], [], []],
            isRunning: false
        }
    }

    get_string_of_stage() {
        if (this.state.stage === 0) return "Loup"
        if (this.state.stage < 4) return "Cochon n°" + this.state.stage
        if (this.state.stage === 403) return "Impossible de placer les maisons"
        return "Tous les éléments sont placés"
    }

    rectClick =  (event) => {
        if (this.state.stage === 4 || this.state.stage >= 403 || this.state.isRunning) return
        let rect = event.target;
        if (rect.classList.contains("nothing") || rect.classList.contains("occuped")) return
        let position = rect.id.split("-")[1].split(",")
        if (this.state.stage === 0) {
            let input = document.getElementById("yuflow-check").checked
            this.setState({wolf: position})
            let img = document.createElement("img")
            img.src = (input) ? img_yuflow : img_wolf
            img.className = "wolf"
            rect.appendChild(img)
            //rect.innerText = "L"
        } else {
            let input = document.getElementById("naruse-check").checked
            let pigs = this.state.pigs
            pigs[this.state.stage - 1] = position
            this.setState({pigs: pigs})
            //rect.innerText = "C"
            let img = document.createElement("img")
            img.src = (input) ? img_ilan : img_pig
            img.className = "pig"
            rect.appendChild(img)
        }

        rect.classList.add("occuped")
        this.setState({stage: this.state.stage + 1})
    }

    copyGame = (e) => {
        let txt = (this.state.wolf.length === 0) ? "null;" : `${this.state.wolf[0]},${this.state.wolf[1]};`
        for (let i = 0; i < 3; i++) {
            if (this.state.pigs[i] === undefined || this.state.pigs[i].length === 0) txt += "null;"
            else txt += `${this.state.pigs[i][0]},${this.state.pigs[i][1]};`
        }
        if (typeof e === "boolean") {
            return txt.substring(0, txt.length - 1);
        } else {
            navigator.clipboard.writeText(txt)
        }
    }

    noElement = () => {
        if (this.state.stage === 4 || this.state.isRunning) return
        this.setState({stage: this.state.stage + 1})
    }

    reset = () => {
        this.setState({stage: 0, wolf: [], pigs: [], isRunning: false})
        let rects = document.querySelectorAll(".rect")
        for (let rect of rects) {
            let newClass = ""
            for (let className of rect.className.split(" ")) {
                if (className === "rect" || className === "nothing") {
                    newClass += className + " "
                }
            }
            rect.innerText = ""
            rect.className = newClass
        }
    }

    showResult = (result) => {
        if (result === "None")  {
            this.setState({stage: 403});
            return;
        }
        this.setState({isRunning: true, stage: 4})
        const house = {
            3: 1,
            4: 2,
            5: 0
        }
        const symbols = {
            3: "plus",
            4: "star",
            5: "minus"
        }
        result = result.split(";;")
        let finalResult = {}
        for (let elt of result) {
            elt = elt.split(":")
            if (elt.length === 1) continue;
            let symbol = elt[0]
            elt[1] = elt[1].substring(1, elt[1].length - 1)
            let positions = elt[1].split(";")
            let pos = []
            for (let position of positions) {
                if (position === "null") pos.push([])
                else pos.push(position.split(","))
            }
            finalResult[symbol] = positions
        }
        let rects = document.querySelectorAll(".rect")
        for (let rect of rects) {
            for (let symbol in finalResult) {
                if (finalResult[symbol].includes(rect.id.split("-")[1])) {
                    let className = "rect"
                    let idx = finalResult[symbol].indexOf(rect.id.split("-")[1])
                    let input = document.getElementById("naruse-check").checked
                    if (!rect.classList.contains("occuped")) {
                        rect.classList.add("occuped")
                    } else {
                        /*let img = rect.children[0]
                        if (symbol === "3") img.src = house_plus
                        if (symbol === "4") img.src = house_star
                        if (symbol === "5") img.src = house_minus*/
                        className += " showpig"
                        if (input) className+= " ilan"
                    }
                    if (idx === house[symbol]) {
                        let img = (rect.childElementCount === 1) ? rect.children[0] : document.createElement("img")
                        if (symbol === "3") img.src = house_plus
                        if (symbol === "4") img.src = house_star
                        if (symbol === "5") img.src = house_minus
                        img.className = "house"
                        if (rect.childElementCount === 0) {
                            rect.appendChild(img)
                        }
                    }
                    rect.className = className
                    rect.classList.add(symbols[symbol])
                }
            }
        }
    }

    runCode = () => {
        let input = this.copyGame(true).split(";");
        let pigs = []
        let wolf = undefined
        for (let i = 0; i <4; i++) {
            if (i === 0) {
                if (input[i] !== "null") {
                    wolf = input[i].split(",")
                    wolf = new Cochon.Position(parseInt(wolf[0]), parseInt(wolf[1]))
                }
            } else {
                let pig = input[i].split(",")
                pigs.push(new Cochon.Position(parseInt(pig[0]), parseInt(pig[1])))
            }
        }
        let game = new Cochon.PigGame(pigs, wolf)
        let possible = game.fillWithHouse()
        let result = ""
        if (possible) {
            for (let i = 0; i < 3; i++) {
                let house = game.houses[i]
                if (house !== undefined) {
                    result += house.toString()
                }
            }
        } else {
            result = "None"
        }
        this.showResult(result)
        /*let input = this.copyGame(true);
        const xhr  = new XMLHttpRequest();
        xhr.open("GET", `http://localhost:3001/cochon/${input}`);
        xhr.send()
        xhr.onload = () => {
            this.showResult(xhr.responseText)
        }*/
    }

    render() {
        let allRect = []
        for (let i = 0; i < 4; i++) {
            let row = []
            for (let j = 0; j < 4; j++) {
                let className = "rect"
                if ((i === 0 && j === 0) || (i === 3 && j === 0) || (i === 0 && j === 3)) className += " nothing"
                row.push(<div onClick={this.rectClick} id={`rect-${i},${j}`} className={className} key={`rect ${i} ${j}`}/>)
            }
            allRect.push(<div className="rect-row" key={`row ${i}`}>{row}</div>)
        }
        return (
            <>
                <header>
                    <h1>3PC Web Interface</h1>
                    <h3>by Tristan Clowez</h3>
                </header>
                <div id="body">
                    <div id="up">
                        <h2>Etape {this.state.stage+1} : {this.get_string_of_stage()}</h2>
                    </div>
                    <div id="map">
                        {allRect}
                    </div>
                    <div id="buttons">
                        <button onClick={this.copyGame} id="copy">Copy</button>
                        <button onClick={this.noElement} id="no-element">No element</button>
                        <button onClick={this.reset} id="reset">Reset</button>
                    </div>
                    <div id="buttons-bottom">
                        <button onClick={this.runCode}>Run</button>
                    </div>
                    <div className="switch-div" id="switch">
                        <p>Yuflow ?</p>
                        <input type="checkbox" id="yuflow-check"/>
                    </div>
                    <div className="switch-div" id="switch2">
                        <p>Naruse ?</p>
                        <input type="checkbox" id="naruse-check"/>
                    </div>
                </div>
                <Analytics />
            </>
        );
    }
}